<template>
    <div v-loading="loading" element-loading-background="rgba(225, 225, 225, 0.5)" element-loading-text="正在生成文件摘要..." style="height:100%">
        <my-form 
            class="form-page" 
            v-model="form" table 
            label-width="180px" 
            :submit-url="`${getGetters('ageUrl')}/FaBiao/ZbFile/`+processType+type+`/add.json`"
            @cancle="cancleHandler">

            <el-form-item 
                label="招标项目名称"
                class="table-full-row">
                    {{formData.zbproname}}
            </el-form-item>

            <template v-if="formData.sfzj==='4'">
                <el-form-item
                label="文件编制人"
                class="table-full-row"
                prop="ext_contactcode"
                :rules="newRule('文件编制人', 'required')">
                    <my-select
                        v-model="form.ext_contactcode"
                        :data="formData.gl"
                        :props="{value:'usercode',label:'username'}"
                    ></my-select>
                </el-form-item>
            </template>

            <template v-if="type === 'cq'">
                <el-form-item
                label="适用招标文件"
                class="table-full-row prewrap"
                key="by1"
                prop="by1"
                :rules="newRule('适用招标文件', 'required')">
                    <mybys-checkbox
                        model-str
                        str-spliter=";"
                        v-model="form.by1"
                        @change="checkZbfile(form.by1)"
                        :data="formData.zbfilelist"
                        :props="{label:'zbfilename',value:'zbfilecode'}"
                    ></mybys-checkbox>
                </el-form-item>

                <el-form-item
                    v-if="formData.xtdq"
                    label="是否变更预算"
                    class="table-full-row">
                        <el-table :data="dataList" border>
                            <el-table-column
                                prop="bdname"
                                label="标段名称"
                                min-width="160">
                            </el-table-column>
                            <el-table-column
                                label="是否变更预算"
                                min-width="160">
                                    <template slot-scope="scope">
                                        <my-radio
                                            v-model="scope.row.izbgys"
                                            :data="[{key:'1', value:'是'},{key:'0', value:'否'}]">
                                        </my-radio>
                                        <div v-if="scope.row.izbgys=='1'">
                                            <el-input 
                                                style="width:150px;margin-top:15px"
                                                type="number"
                                                v-model.number="scope.row.bgys" 
                                                placeholder="请输入内容">
                                            </el-input>万元 人民币
                                        </div>
                                        
                                    </template>
                            </el-table-column>
                        </el-table>
                </el-form-item>

                <el-form-item
                label="答疑澄清时间"
                class="table-full-row"
                prop="dycqtime"
                :rules="newRule('答疑澄清时间', 'required')">
                    <el-date-picker
                        v-model="form.dycqtime"
                        :picker-options="datePickerOptions"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm"
                        format="yyyy-MM-dd HH:mm"
                    >
                    </el-date-picker>
                </el-form-item>
            </template>

            <el-form-item 
                label="招标文件"
                class="table-full-row">
                    <VueWebUpload 
                        uploadUrl="/standalonfile/upload/tendering/bigfileup.json" 
                        :accept="filetype"
                        :fileguid='formData.fileguid' 
                        :headers="{ 'Authorization': 'Bearer 2741145f-0065-4e37-9e24-a6d42ca22254'}" 
                        :auto-upload="true" 
                        :on-success="uploadSuccess" 
                        @loading="loadingFun"
                        :file-list="fileList">
                    </VueWebUpload>
            </el-form-item>

            <el-form-item
            class="table-full-row"
            label="受理质疑电话"
            prop="complaintsphone"
            :rules="newRule('受理质疑电话', 'required', 'mobile')">
                <el-input
                    v-model="form.complaintsphone">
                </el-input>

                <my-tag type="danger">（该手机号将被用于接收投标人在平台内提出对招标文件质疑的短信提醒）</my-tag>
            </el-form-item>

            <template v-if="flag">
                <el-form-item 
                label="开标时间">
                    {{formData.zbwjmodel.kbtime}}
                </el-form-item>

                <el-form-item 
                label="文件递交截止时间">
                    {{formData.zbwjmodel.tbwjdjjztime}}
                </el-form-item>

                <el-form-item 
                label="投标文件递交方法/平台地址">
                    {{formData.zbwjmodel.tbwjdjff}}
                </el-form-item>

                <el-form-item 
                label="递交时间">
                    {{formData.zbwjmodel.djtime}}
                </el-form-item>

                <el-form-item 
                label="投标保证金">
                    {{formData.zbwjmodel.tbbzj}}{{formData.zbwjmodel.jedwname}}{{formData.zbwjmodel.bzname}}
                </el-form-item>

                <el-form-item 
                label="投标有效期(天)">
                    {{formData.zbwjmodel.tbyxq}}
                </el-form-item>

                <el-form-item 
                label="开标方式">
                    {{formData.zbwjmodel.kbfs}}
                </el-form-item>

                <el-form-item 
                label="资格审查方式">
                    {{formData.zbwjmodel.zgscfs}}
                </el-form-item>

            </template>

            <template v-if="formData.iszfcg">

                <el-form-item
                label="供货时间"
                prop="projectduration"
                :rules="newRule('供货时间', 'required')">
                    <el-input v-model="form.projectduration"></el-input>
                </el-form-item>

                <el-form-item
                label="开标地点"
                prop="bidopenaddr"
                :rules="newRule('开标地点', 'required')">
                    <el-input v-model="form.bidopenaddr"></el-input>
                </el-form-item>

                <el-form-item
                class="table-full-row"
                label="需要落实的政府采购政策"
                prop="implementpolicy"
                :rules="newRule('需要落实的政府采购政策', 'required')">
                    <my-checkbox
                        model-str
                        str-spliter=";"
                        v-model="form.implementpolicy"
                        :data="zclist"
                        :props="{label:'name',value:'value'}">
                    </my-checkbox>
                </el-form-item>

                <el-form-item
                class="table-full-row"
                label="简要技术要求（或采购项目性质）"
                prop="technicalrequirements"
                :rules="newRule('简要技术要求（或采购项目性质）', 'required')">
                   <el-input 
                        type="textarea" 
                        :autosize="{ minRows: 4, maxRows: 10}"
                        v-model="form.technicalrequirements">
                    </el-input>
                </el-form-item>

            </template>

            <template v-if="flag">

                <el-form-item 
                class="table-full-row"
                label="投标资格">
                    {{formData.zbwjmodel.tbzg}}
                </el-form-item>

                <el-form-item
                class="table-full-row"
                label="评标办法">
                    {{formData.zbwjmodel.pbbf}}
                </el-form-item>

            </template>

            <template v-if="formData.ishbpsp=='1'">

                <el-form-item 
                class="table-full-row"
                label="是否推送河北省招标投标公共服务平台">
                    <my-radio
                        v-model="form.ishbpsp"
                        :data="[{key:'1', value:'是'},{key:'0', value:'否'}]">
                    </my-radio>
                </el-form-item>

            </template>

            <el-form-item
                class="table-full-row"
                label="招标备案表"
                v-if="formData.izsjjt"
                :rules="newRule('招标备案表', 'required')">
                    <span slot="label">
                        {{type==='cq' ? '招标澄清备案表' : '招标备案表'}}
                    </span>
                    <el-link type="primary" @click="mobandown" target="_blank">模板下载</el-link>
                    <my-upload 
                        :typecode="type==='cq' ? 'wjcqbab' : 'wjbab'"
                        :file-guid="formData.babguid|| ''" 
                        file-type=".pdf"  
                        :file-size="1024">
                    </my-upload>
            </el-form-item>

            <template slot="btn" slot-scope="scope">
                <div v-if="type==='cq'">
                    <el-checkbox v-model="form.sjxz">
                        取消澄清文件必须在开标时间15日前发布的时间限制（澄清内容对投标人制作投标文件没有实质性影响）
                    </el-checkbox>
                </div>
                <el-button type="primary" icon="el-icon-circle-check" @click="saveHandler(1,scope.submitHandler)" v-if="formData.cakeybj==false">
                    提交
                </el-button>
                <ca-activation type="primary" icon="el-icon-circle-check" @click="saveHandler(1,scope.submitHandler,$event)" v-if="formData.cakeybj==true">
                    提交
                </ca-activation>
                <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
            </template>
        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import VueWebUpload from '@views/bidding/components/VueWebUpload/VueWebUpload'
import CaActivation from '@/components-sys/ca-activation'
import mybysCheckbox from './components/mybys-checkbox'
import storage from '@js/storage.js'
export default {
    mixins: [ FORM_PAGE_MIXIN],
    components: {
        VueWebUpload,CaActivation,mybysCheckbox
    },
    data() {
        return{
            formData:{},
            form:{
                ishbpsp:'',
                sjxz:false,
                implementpolicy:'',
                zbfilecode:'',
                zbfilename:'',
                dycqtime:'',
                zbproname:'',
                data:'',
                scbj:'',
                complaintsphone:'',
                procode:'',
            },
            type:'',
            fileList: [],
            flag:false,
            zclist:[
                { name: '《中华人民共和国招标投标法》', value: '《中华人民共和国招标投标法》' },
                { name: '《中华人民共和国招标投标法实施条例》', value: '《中华人民共和国招标投标法实施条例》' },
                { name: '详见招标文件', value: '详见招标文件' },
            ],
            isXt:'',
            processType:'',
            fileHash:'',
            caObjectVal:{},
            loading:false,
            // 时间禁止之前
            datePickerOptions: {
                disabledDate(time) {
                    var today = new Date().pattern('yyyy/MM/dd');
                    return time.getTime() < new Date(today).getTime();
                }
            },
            filetype:window._config.zbfileType,
            dataList:[],
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        // 选择招标文件
        checkZbfile(val){
            var that = this;
            that.dataList = [];
            var flieList = val.split(';');
            flieList.forEach(function(item){
                that.formData.zbfilelist.forEach(function(obj){
                    if(item==obj.zbfilecode){
                        var initObj = { bdname:obj.bdname,bdcode:obj.bdcode,izbgys:'0',bgys:'',}
                        that.dataList.push(initObj);
                    }
                })
            })
        },
        uploadSuccess(res, file, fileList) {
            this.form.data = JSON.stringify(res.tdata[0]);
            this.fileHash = res.tdata[0].sha1
            if(res.code=='v'){
                ShowMsg('上传成功，提交后生效！', 'success');
            }else{
                ShowMsg(res.msg, 'error');
            }
            
        },
        saveHandler(shbj,cb,type) {
            var that = this;
            for(var i=0; i<that.dataList.length;i++){
                if(that.dataList[i].izbgys=='1'){
                    if(that.dataList[i].bgys==''){
                        ShowMsg('请输入变更预算内容');
                        return
                    }
                }
            }
            that.form.updateJson = JSON.stringify(that.dataList)
            if (this.form.data == '') {
                ShowMsg("请先上传文件，成功后再进行提交！",'warning');
                return;
            }
            if(type){
                this.form.caType = type
            }
            
            this.form.shbj = shbj
            this.form.scbj = '0'
            that.form.babguid = that.formData.babguid;
            that.form.zbprocode = that.formData.zbprocode;
            that.form.zbproname = that.formData.zbproname;
            if(that.formData.iszfcg&&that.form.implementpolicy==''){
                ShowMsg('请选择需要落实的政府采购政策！','warning');
                return;
            }
            if(that.formData.cakeybj){
                that.caObjectVal.character = that.fileHash;
                that.form.hfFileZy = that.fileHash;
                //签名
                useCA(that.form.caType, 'sign', that.caObjectVal, function (res) {
                    that.form.hfQm = res.signData;
                        //获取证书对象
                    useCA(that.form.caType, 'getCertB64', that.objectVal, function (res) {
                        that.form.hfUserZs = res.signCert;
                        that.form.sCert = res.signCert;
                        //ca单位名称
                        useCA(that.form.caType, 'getcadwname', that.objectVal, function (res) {
                            if (that.formData.dwname == res.cadwname) {
                                cb && cb();
                            }else{
                                ShowMsg('CA单位名称与当前登录单位名称不一致！', 'error');
                            }
                        })
                    })
                })
                
            }else{
                cb && cb();
            }
        },

        // 上传遮罩
        loadingFun(val){
            if(val=='1'){
                this.loading = true
            }else{
                this.loading = false
            }
        },
         // 下载模板
        mobandown(){
            if(this.type=='cq'){
                window.open("./static/bidding/files/河北省交通运输工程项目招标文件补遗澄清备案表.docx") 
            }else{
                window.open("./static/bidding/files/河北省交通运输工程项目招标文件备案表.docx") 
            }
            
        },
    },
    created() {
        var that = this;
        that.type=that.getQuery('pageType');
        that.isXt = that.getQuery('isXt');
        if(that.isXt=='1'){
            that.processType = 'xingtai/'
        }
        that.jspInit(`${that.getGetters('ageUrl')}/FaBiao/ZbFile/`+that.processType+that.type+`/edit.json`,that.detailExtra,(data, res) => {
            that.formData = data;
            if (!data.izSfRz) {
                that.$alert('登录身份已切换，请退出并重新登录后再进行操作！', '提示', {
                    confirmButtonText: '确定',
                    type: 'error',
                    callback: function(action) {
                        that.$get(`${that.getGetters('mngUrl')}/admin/revision/logout.json`,{
                        }, (data, res) => {
                            var user = storage.getSession('user')
                            // 返回旧系统登录(代理)
                            if(user.identityType==='T'){
                                window.location.href = 'http://'+window.location.host + '/admin/tender/login'
                            }else{
                                window.location.href = 'http://'+window.location.host + '/admin/login'
                            }
                        });
                    }
                })
            }
            if(data.zbwjmodel&&that.isXt!='1'){
                that.form.ishbpsp = data.zbwjmodel.ishbpsp||'';
                
                that.form.zbfilename = data.zbwjmodel.zbfilecode||'';
                that.form.dycqtime = data.zbwjmodel.dycqtime||'';
            }
            if(that.type=='cq'){
                if(data.zbwjmodel.izbgys&&data.zbwjmodel.izbgys=='1'){
                    that.dataList.push({ 
                        bdname:data.zbwjmodel.bdname,
                        bdcode:data.zbwjmodel.bdcode,
                        izbgys:data.zbwjmodel.izbgys,
                        bgys:data.zbwjmodel.bgys,
                    })
                }
            }
            
            that.form.zbfilecode = data.zbfilecode||'';
            if(that.form.zbfilecode){
                that.flag = true
            }
            that.form.procode = data.procode
            that.form.zgys = that.getQuery('zgys');
            
        });
       
    },
    mounted() {
        
    }
}
</script>

<style>
    .prewrap .el-checkbox__label{ white-space: pre-wrap; }
</style>
